import React from "react"
import CustomPhoneInput from "."
import { useLang } from "hooks/useLang"

interface IProps {
    phoneNumber: string
    setPhoneNumber: (phoneNumber: string) => void
    callingCode: string
    setCallingCode: (callingCode: string) => void
    error?: string
    autoFocus?: boolean
    readOnly?: boolean
    reqStar?: boolean
    id?: string
}

const PhoneComponent = ({
    phoneNumber,
    setPhoneNumber,
    callingCode,
    setCallingCode,
    error,
    autoFocus,
    readOnly,
    reqStar,
    id,
}: IProps) => {
    const { t } = useLang()

    return (
        <div className="flex flex-col">
            <label
                htmlFor={id}
                className={`pb-1 text-sm capitalize text-gray-600 transition-all dark:text-gray-200 md:text-base ${
                    reqStar ? "after:text-red-500 after:content-['*']" : ""
                }`}>
                {t("phoneNumber")}
            </label>
            <CustomPhoneInput
                id={id}
                phone={phoneNumber}
                setPhone={setPhoneNumber}
                country={callingCode}
                setCountry={setCallingCode}
                required={true}
                error={error}
                autoFocus={autoFocus}
                readOnly={readOnly}
            />
            {error ? (
                <span className="pt-1 text-xs text-red-500 dark:text-red-400">
                    {t(error)}
                </span>
            ) : null}
        </div>
    )
}

export default PhoneComponent
